const webSocketFunc = (userObj) => {
    return {
        type: "ADD_WEBSOCKET",
        payload: userObj
    }
}

export default {
    webSocketFunc
}